import { useEffect } from "react";
export const useKeyboardNav = ({ handleArrowRight, handleArrowLeft, handleEscape, }) => useEffect(() => {
    const handleKeyDown = (e) => {
        if (e.key === "ArrowRight" && handleArrowRight) {
            handleArrowRight();
        }
        if (e.key === "ArrowLeft" && handleArrowLeft) {
            handleArrowLeft();
        }
        if (e.key === "Escape" && handleEscape) {
            handleEscape();
        }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
        window.removeEventListener("keydown", handleKeyDown);
    };
});
